export const searchEntitiesFiltersParser = ({ industrySectors, countries }, industries) => ({
  ...(countries ? { countries } : {}),
  ...(industrySectors
    ? {
        sector: industrySectors.map(item => {
          const sector = industries.find(({ code }) => item.sector === code);

          return sector.name;
        }),
      }
    : {}),
});

export const searchNewsFiltersParser = ({ industrySectors }) => {
  return industrySectors ? { industrySectors } : {};
};

export const searchNewsQueryParser = (query, filters, countries) => {
  const queryString = query || '';

  if (!filters.countries || !filters.countries.length) {
    return queryString;
  }

  const countriesQueryString = filters.countries
    .map(item => {
      const country = countries.find(({ iso }) => item === iso);

      return country.name;
    })
    .join(' ');

  return `${queryString} ${countriesQueryString}`;
};
